<template>
  <div class="text-center">
    <v-icon size="100" color="error">mdi-alert-circle-outline</v-icon>
    <div class="mt-5">
      <slot />
    </div>
  </div>
</template>
